import { mailModuleName } from './strings.locstring.json';
import loc from 'owa-localize';
// Order is important, do not mess with it :)
import * as React from 'react';
import { bootstrap } from 'owa-bootstrap';
import initializeMailModuleState from './actions/initializeMailModuleState';
import MailModule from 'owa-mail-module-view/lib/components/MailModule';
import { mailRouterOptions, initializeMailRoutes } from './routing/mailRoutes';

import { runAfterInitialRender } from 'owa-delayed-initialization';
import initializeNotifications from './initializeNotifications';
import initializeServiceWorker from './initializeServiceWorker';
import initializePersona from './initializePersona';
import { isFeatureEnabled } from 'owa-feature-flags';
import { OwaWorkload } from 'owa-workloads';
import { controlIconRegistration } from 'owa-control-icons';
import { mailIconsRegistration } from 'owa-mail-icons';
import { addinIconsRegistration } from 'owa-addins-icons';
import { surfaceActionIconsRegistration } from 'owa-surface-action-icons';
import { initializeMailFavicon } from 'owa-mail-favicon';
import initializeNewMailNotificationFilter from './initialization/initializeNewMailNotificationFilter';
import { getMailAnalyticOptions } from 'owa-mail-shared-analytics';
import { logSubjectPickerInitInfo } from 'owa-mail-subject-picker-connector';
import initializeExtensibilityContext from './initializeExtensibilityContext';
import 'owa-attachment-preview-initialization/lib/utils/initializeAttachmentPreviewInSxS';
import connectedAccountsNotificationOperation from 'owa-service/lib/operation/connectedAccountsNotificationOperation';
import initializeLandmarkKeyboardNavigation from './initialization/initializeLandmarkKeyboardNavigation';
import { startTrackingFps } from 'owa-fps';
import { PreBootOptions } from 'owa-config';
import { initializeSkypeForBusiness } from 'owa-skype-for-business';
import {
    satchelDiagnosticsMiddleware,
    legacySatchelDiagnosticsMiddleware,
} from 'owa-diagnostics-common/lib/satchel/satchelDiagnosticsMiddleware';
import { lazyGetMailModuleDiagnostics } from 'owa-mail-diagnostics';

export default function bootstrapMailModule(bootstrapConfig: PreBootOptions): Promise<void> {
    const bootstrapPromise = bootstrap({
        initializeState: initializeMailModuleState,
        renderMainComponent: () => <MailModule />,
        initialConfig: bootstrapConfig,
        location: window.location,
        registerRoutes: initializeMailRoutes,
        routerOptions: mailRouterOptions,
        getModuleName: () => loc(mailModuleName),
        workload: OwaWorkload.Mail,
        analyticsOptions: getMailAnalyticOptions(),
        iconFonts: [
            controlIconRegistration,
            mailIconsRegistration,
            addinIconsRegistration,
            surfaceActionIconsRegistration,
        ],
        satchelMiddleware: [satchelDiagnosticsMiddleware],
        satchelLegacyMiddleware: [legacySatchelDiagnosticsMiddleware],
    });

    runAfterInitialRender(() => {
        if (isFeatureEnabled('fwk-perf-fps')) {
            startTrackingFps();
        }

        if (isFeatureEnabled('fwk-devTools')) {
            // Initialize the singleton diagnostics store to register the diagnostics listeners
            lazyGetMailModuleDiagnostics
                .import()
                .then(getMailModuleDiagnostics => getMailModuleDiagnostics());
        }

        initializeNotifications();
        initializeLandmarkKeyboardNavigation();
        initializeServiceWorker(window, 'mail');
        initializePersona();
        initializeMailFavicon();
        initializeNewMailNotificationFilter();
        initializeExtensibilityContext();
        logSubjectPickerInitInfo();
        connectedAccountsNotificationOperation({
            isOWALogon: true,
        });
        initializeSkypeForBusiness();
    });

    return bootstrapPromise;
}
